;(function module() {
  angular.module('app.ui.form.ctrls').controller('EmailListingController', [
    'usSpinnerService',
    '$q',
    'logger',
    'EmailApi',
    '$scope',
    'userService',
    function controller(
      usSpinnerService,
      $q,
      logger,
      EmailApi,
      $scope,
      userService
    ) {
      let vm = this
      vm.searchEmailQuery = ''
      var originalEmailListing = []
      vm.numPerPageOpt = [10, 20, 50]
      vm.numPerPage = vm.numPerPageOpt[2]
      vm.currentPage = 1
      vm.currentPageItems = []
      vm.isEditedFieldCC = false
      vm.isEditedFieldBCC = false
      vm.hideDropDown = () => {
        vm.showClass = ''
      }

      vm.showClass = ''
      vm.showDropDown = () => {
        if (vm.showClass === '') {
          vm.showClass = 'show'
        } else {
          vm.showClass = ''
        }
      }

      vm.startSpin = spinnerID => {
        if (!vm.spinneractive) {
          usSpinnerService.spin(spinnerID)
          vm.spinneractive = true
          return vm.startcounter++
        }
      }

      vm.stopSpin = spinnerID => {
        if (vm.spinneractive) {
          usSpinnerService.stop(spinnerID)
          vm.spinneractive = false
        }
      }

      vm.searchEmail = () => {
        let filteredResult
        filteredResult = []
        if (vm.searchEmailQuery === '') {
          vm.emailListing = originalEmailListing
        } else {
          filteredResult = filterResult(vm.searchEmailQuery)
          vm.emailListing = filteredResult
        }

        vm.select(1)
      }

      const filterResult = searchQuery => {
        let index
        let k
        let reference
        let searchResults
        searchResults = []
        for (
          index = 0, k = 0, reference = originalEmailListing.length;
          reference >= 0 ? k < reference : k > reference;
          index = reference >= 0 ? ++k : --k
        ) {
          if (
            originalEmailListing[index].label
              .toUpperCase()
              .search(searchQuery.toUpperCase()) !== -1
          ) {
            searchResults.push(originalEmailListing[index])
          } else if (
            originalEmailListing[index].id &&
            originalEmailListing[index].id
              .toUpperCase()
              .search(searchQuery.toUpperCase()) !== -1
          ) {
            searchResults.push(originalEmailListing[index])
          }
        }

        return searchResults
      }

      vm.editEmailField = (email, type) => {
        if (type === 'cc') {
          email.isEditedFieldCC = true
          vm.emailInputCCField = email[type]
        } else {
          vm.emailInputBCCField = email[type]
          email.isEditedFieldBCC = true
        }
      }
      // TODO: Implement this functionality of display context of email from sendGrid in v1.1.0
      // vm.openEmailBodyViewPage = email => {
      //   $location.url('/admin/email-body').search({
      //     email: email,
      //   })
      // }

      vm.updateEmail = async (updatedEmail, type) => {
        if (type === 'cc') vm.emailInputField = vm.emailInputCCField
        else vm.emailInputField = vm.emailInputBCCField

        if (vm.emailInputField === '')
          logger.notify('error', `Email ${type} should not be Empty`)
        else {
          const existingValue = originalEmailListing.find(
            ({id}) => id === updatedEmail.id
          )[type]
          if (existingValue === vm.emailInputField) {
            logger.notify('error', `Email ${type} should not be Same`)
          } else {
            const dto = {
              [type]: vm.emailInputField.trim(),
            }
            try {
              const {status} = await EmailApi.updateEmailById(
                updatedEmail.id,
                dto
              )
              if (status === 200) {
                updatedEmail[type] = vm.emailInputField.trim()
                logger.notify('success', `Email ${type} successfully updated`)
                // eslint-disable-next-line max-depth
                if (type === 'cc') {
                  updatedEmail.isEditedFieldCC = false
                  $scope.$apply()
                } else {
                  updatedEmail.isEditedFieldBCC = false
                  $scope.$apply()
                }
              }
            } catch (error) {
              console.error('UpdateEmail Error:', error)
              logger.notify('error', `Email ${type} failed`)
            }
          }
        }
      }

      //  TODO: Removed as per discussion this will Implement History Functionality in v.1.1.0
      // vm.showHistory = () => {
      //   return $location.url('/admin/email-history')
      // }

      vm.loadEmailList = async (start, end) => {
        vm.user = await userService.getUser()
        vm.showEmailListing = true
        vm.listingTitle = 'Email Listing'
        vm.numPerPage = vm.numPerPageOpt[2]
        vm.startSpin('spinner-2')
        if (!start) {
          start = 0
        }

        if (!end) {
          end = vm.numPerPage
        }

        return $q.all([EmailApi.getAllEmails()]).then(
          function success(responses) {
            const emailListingResponse = responses[0]
            const data = emailListingResponse.data
            vm.totalEmailList = data.length
            originalEmailListing = data
            originalEmailListing = originalEmailListing.map(email => {
              email.active = email.active ? 'Active' : 'Archived'
              return email
            })
            vm.populateEmailList(data)
            vm.stopSpin('spinner-2')
          },
          function error() {
            vm.stopSpin('spinner-2')
          }
        )
      }

      vm.populateEmailList = data => {
        vm.stopSpin('spinner-2')
        vm.emailListing = data
        vm.select(1)
      }

      vm.onNumPerPageChange = () => {
        vm.select(1)
        vm.currentPage = 1
        return vm.currentPage
      }

      vm.onOrderChange = () => {
        vm.select(1)
        vm.currentPage = 1
        return vm.currentPage
      }

      vm.orderEmailListing = (key, order) => {
        vm.sortBy = `${key}_${order}`
        if (order === 'asc') {
          vm.emailListing = _.sortBy(vm.emailListing, key)
        } else {
          vm.emailListing = _.sortBy(vm.emailListing, key).reverse()
        }

        vm.onOrderChange()
      }

      vm.select = page => {
        const start = (page - 1) * vm.numPerPage
        const end = start + vm.numPerPage
        vm.listing = vm.emailListing.slice(start, end)
      }

      vm.loadEmailList()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/admin-panel/email-listing/email-listing.ctrl.js